import React from "react";
import { SprintPageInternal } from "./Sprints";


interface Props {
}

interface State {
}

export class Home extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {};
    }

    public render() {
        return <SprintPageInternal />
    }
}
